const BUDGETS = [
  {
    name: "create-new-product",
    owner: "Angad Sethi",
    budget: 2000,
  },
  {
    name: "create-user.component",
    owner: "Srivathsan Baskaran",
    budget: 3000,
  },
  {
    name: "customer-shop",
    owner: "John Doe",
    budget: 2500,
  },
  {
    name: "displayresults",
    owner: "Jane Doe",
    budget: 2098,
  },
  {
    name: "login",
    owner: "Ashok Gupta",
    budget: 1435,
  },
  {
    name: "main",
    owner: "Angad Sethi",
    budget: 143598,
  },
  {
    name: "runtime-main",
    owner: "Srivathsan Baskaran",
    budget: 29393,
  },
  {
    name: "users-list.component",
    owner: "Ashok Gupta",
    budget: 48392,
  },
  {
    name: "vendor-shop",
    owner: "Angad Sethi",
    budget: 1435,
  },
  {
    name: "Game",
    owner: "Richit Malhotra",
    budget: 1984,
  },
];

export default BUDGETS;
